import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { CheckCircle, LoaderCircle, XCircle } from "lucide-react";
import { Button } from "@/components";
import { useApi } from "@/";
import { useEffect, useState } from "react";

const VerifiedEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const location = useLocation();
  const [isVerified, setIsVerified] = useState(false);
  const { callApi, loading } = useApi();
  const errorMessage =
    "Your email verification failed. Please try again later.";

  useEffect(() => {
    const verifyEmail = async () => {
      if (token) {
        try {
          const response = await callApi("common//verify-email", "POST", {
            token: token,
          });
          if (response.success) {
            setIsVerified(true);
          } else if (response.error?.message) {
            setIsVerified(false);
          }
        } catch (error) {
          console.error("Email verification failed:", error);
          setIsVerified(false);
        }
      }
    };
    verifyEmail();
  }, [token, callApi]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background via-background_2 to-background p-6">
      <div className="bg-secondary rounded-[32px] shadow-2xl p-8 max-w-lg w-full text-center">
        {loading ? (
          <div className="flex flex-col items-center justify-center">
            <LoaderCircle className="h-20 w-20 animate-spin text-background" />
            <p className="text-background/60 text-lg mt-4">
              Verifying your email...
            </p>
          </div>
        ) : (
          <>
            <div className="flex justify-center mb-4">
              {isVerified ? (
                <CheckCircle className="w-20 h-20 text-green-500" />
              ) : (
                <XCircle className="w-20 h-20 text-red-500" />
              )}
            </div>
            <h1 className="text-4xl font-bold text-background/95 mb-2">
              {isVerified ? "Email Verified!" : "Verification Failed"}
            </h1>
            <p className="text-background/60 text-lg mb-6">
              {isVerified
                ? "Your email has been successfully verified. You can now proceed to login."
                : errorMessage}
            </p>
            <Button
              onClick={() => navigate("/login")}
              className="w-full py-3 bg-secondary hover:!bg-background/10 text-background font-semibold rounded-lg transition-colors"
              isLoading={loading}
            >
              Go to Login
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifiedEmail;
